import clsx from "clsx"

import { Heading } from "@components/typography"
import { Container } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@const/pictures"
import Image from "next/image"

export function RisebinarBanner() {
  return (
    <div
      className={clsx(
        "text-white sm:h-[48vw] relative",
        "sm-only:h-[60vw]"
        // "text-white sm:h-[48vw] relative sm:mb-[120px]"
        // "sm-only:h-[110vw] mb-[62vw]"
      )}
    >
      <Image
        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/risebinar_banner_3.png`}
        alt="harisenin-risebinar-banner"
        className={clsx("w-full sm:h-[48vw] object-cover", "h-full")}
        width={1440}
        height={684}
      />

      <div
        className={clsx(
          "absolute top-0 left-0 bg-[rgba(0,41,95,0.8)] w-full h-full flex flex-col justify-center"
          // "sm-only:pt-[80px] sm-only:pb-[180px]"
        )}
      >
        <Container>
          <div className="max-w-[540px]">
            <Heading headingLevel="banner" id="tagline" className="text-white sm:mb-5 mb-2.5">
              Event & Workshop
            </Heading>
            <h5 className={clsx("sm:text-md sm:leading-[174%]", "text-sm leading-4.5")}>
              Webinar dari Harisenin.com bertujuan untuk memberikan berbagai pelatihan yang
              berkaitan dengan industri digital. Disini, kamu bisa mengupas berbagai macam topik
              mulai dari digital marketing, tech & product, keuangan, bisnis hingga design grafis.
            </h5>
          </div>
        </Container>
      </div>

      {/* <RiasecColumn /> */}
    </div>
  )
}
